import { render, staticRenderFns } from "./AppDialogContainer.vue?vue&type=template&id=c1778ea2&scoped=true&"
import script from "./AppDialogContainer.vue?vue&type=script&lang=ts&"
export * from "./AppDialogContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1778ea2",
  null
  
)

export default component.exports